import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Footer = () => (
  <footer className="main-footer">
    <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/vobo.io">
      <FontAwesomeIcon icon={['fab', 'facebook']} size="2x" />
    </a>
    <p>&copy; Copyright Vobo 2018</p>
  </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/browser/components/Footer.js